export default function NFT() {
  const tribes = [
    {
      id: 1,
      name: "Lacedameon",
      image: "https://static.lumi.new/11/116ddcfc84e84b4f6b5298ebbfb31866.webp",
      description: "Gallant warriors, defenders of light and life.",
      link: "https://opensea.io/collection/lacedameon"
    },
    {
      id: 2,
      name: "Cyborx",
      image: "https://static.lumi.new/3a/3ad1e27a364daa29e2c3f9793523317a.webp",
      description: "Cyborg humanoid scientists, whom captured and created the Bio Apes.",
      link: "https://opensea.io/collection/cyborxnft"
    },
    {
      id: 3,
      name: "Bio Apes",
      image: "https://static.lumi.new/40/40eebfd38fe045fe472b910499e94c09.webp",
      description: "Apes that were captured and experimented on by the Cyborx, who escaped and seek revenge!",
      link: "https://opensea.io/collection/bioapesclub"
    },
    {
      id: 4,
      name: "The Lost Kids",
      image: "https://static.lumi.new/e6/e6f2cf0fbd4abf6326fedcea4dcbc8f7.webp",
      description: "Kids who fled with the EVA tribe and got lost in orbit and became orphans while the Cyborx were plotting their attack on the Lacedameon in order to harness the Mandox gem and use it for evil.",
      link: "https://opensea.io/collection/thelostkids"
    },
    {
      id: 5,
      name: "EVA",
      image: "https://static.lumi.new/37/3722536fed6846ab74d9c6a871f40abe.webp",
      description: "This collection was made to celebrate all the women in web3. EVA tribe are the guardians of the Lost Kids, who fled from an ambush attack on the Lacedameon.",
      link: "https://opensea.io/collection/evatribe"
    },
    {
      id: 6,
      name: "The Fallen",
      image: "https://static.lumi.new/cf/cfa36e39599d93f9bc0c11552f91ad7a.webp",
      description: "Greedy Lacedameon warriors who wanted to use the Mandox for evil became cursed and betrayed their own people.",
      link: "https://opensea.io/collection/discoverthemandox"
    },
    {
      id: 7,
      name: "Lycans",
      image: "https://static.lumi.new/a6/a6fe6a71dd04fe9599b8f00988034bef.webp",
      description: "The Fallen had the ability to turn themselves into Lycans. The Fallen and Lycans were against all tribes trying to harness the Mandox Gem for their own power and greed.",
      link: "https://opensea.io/collection/discoverthemandox"
    },
    {
      id: 8,
      name: "Dream Weavers",
      image: "https://static.lumi.new/53/5342eecbe8b57715a2a9414ff8867ff7.webp",
      description: "God-like race with mind bending, telekinetic powers.",
      link: "https://opensea.io/collection/thedreamweavers"
    }
  ]

  return (
    <section className="relative py-20 px-4 z-10 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 pt-16 text-center">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 text-white">
            NFT Tribes
          </h2>
          <div className="max-w-5xl mx-auto space-y-6 text-left px-4">
            <p className="text-base md:text-lg text-white/80 leading-relaxed">
              Mandox NFTs form an epic, multi-chapter collection titled "Discover the Mandox," centered on a cosmic journey through <strong className="text-white">8 distinct tribes</strong>. The narrative unfolds across a universe where time held no meaning, 10 planets emerged, and three suns illuminated the central world of Actaeon. This sacred planet was discovered by the Lacedameon tribe, guardians who harnessed the eternal light known as the Mandox—a radiant force of life that darkness could never extinguish.
            </p>
            <p className="text-base md:text-lg text-white/80 leading-relaxed">
              Opposing this light are shadowy exiles, the Fallen Ones, who seek to corrupt and wield the Mandox for destruction, threatening all existence.
            </p>
            <p className="text-base md:text-lg text-white/80 leading-relaxed">
              The 8 tribes—each represented by unique hand-drawn NFT characters—embody different facets of this unfolding saga:
            </p>
            <ul className="text-base md:text-lg text-white/80 leading-relaxed space-y-2 list-none pl-6">
              <li>• <strong className="text-white">Lacedameon</strong> (the original protectors of the light)</li>
              <li>• <strong className="text-white">Cyborx</strong></li>
              <li>• <strong className="text-white">BioApes</strong></li>
              <li>• <strong className="text-white">Eva</strong></li>
              <li>• <strong className="text-white">Lost Kids</strong></li>
              <li>• <strong className="text-white">The Fallen</strong></li>
              <li>• <strong className="text-white">Lycans</strong></li>
              <li>• <strong className="text-white">Dream Weavers</strong></li>
            </ul>
            <p className="text-base md:text-lg text-white/80 leading-relaxed">
              Together, these tribes weave a rich, interconnected lore of discovery, conflict, and power in a battle between light and encroaching darkness.
            </p>
          </div>
        </div>

        {/* Video Section */}
        <div className="mb-16 max-w-5xl mx-auto px-4">
          <div className="relative rounded-lg overflow-hidden shadow-[0_0_40px_rgba(255,255,255,0.4)] hover:shadow-[0_0_60px_rgba(255,255,255,0.6)] transition-all duration-300">
            <div className="relative pb-[56.25%] h-0">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/q85qR9AYJMk"
                title="Mandox Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 px-4">
          {tribes.map((tribe) => (
            <div
              key={tribe.id}
              className="group relative transition-all duration-300 hover:-translate-y-2"
            >
              <div className="aspect-square overflow-hidden rounded-lg mb-4 shadow-lg hover:shadow-[0_0_30px_rgba(255,255,255,0.3)] transition-all duration-300">
                <img
                  src={tribe.image}
                  alt={tribe.name}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-white/90 transition-colors">
                  {tribe.name}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed mb-4">
                  {tribe.description}
                </p>
                <a
                  href={tribe.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-white text-black px-6 py-2 rounded-lg font-semibold hover:bg-white/90 transition-all duration-300 shadow-lg hover:shadow-[0_0_20px_rgba(255,255,255,0.5)]"
                >
                  View on OpenSea
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
